module.exports = __webpack_public_path__ + "static/media/icon_panel_closed.d5d822e4.svg";